import branchManagementBillingApprovalComponent from './billing_approval.component';

let branchManagementBillingApprovalModule = angular.module('branchManagementBillingApproval', [])
  .component('branchManagementBillingApproval', branchManagementBillingApprovalComponent)
  .name;

export default branchManagementBillingApprovalModule;


// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/billing_approval/index.js